import React, { useEffect } from "react";
import clsx from "clsx";

import { DELAY_MINIMUM_OPEN_TIME } from "../../../libs/common";

import useCamera from "../../../hooks/useCamera";
import usePhotoLibrary from "../../../hooks/usePhotoLibrary";

import CommonPopup from "..";
import { GalleryPictureIcon, TakePictureIcon } from "../../Input/ImageUpload";
import CommonButton from "../../Button";

import { DefaultImageIcon } from "../../../pages/MyInfo";

type Props = {
  popup: string;
  onClose?: () => void;
  onChangeImage?: (image?: string[]) => void;
  isProfile?: boolean;
  maxCount?: number;
  onCall?: () => void;
  title?: string;
  type?: "profile" | "board" | "workBefore" | "workAfter" | "center";
};

export default function ImageUploadPopup({
  popup,
  onCall,
  onClose,
  onChangeImage,
  title,
  type = "profile",
  maxCount = 1,
  isProfile = false,
}: Props) {
  const [cameraResult, callCamera] = useCamera();
  const [photoResult, callPhoto] = usePhotoLibrary();
  const [delayedPopup, setDelayedPopup] = React.useState("");

  useEffect(() => {
    if (cameraResult.isLoading === false && cameraResult.result) {
      onChangeImage?.(cameraResult.result);
    }
  }, [cameraResult.isLoading, cameraResult.result]);

  useEffect(() => {
    if (photoResult.isLoading === false && photoResult.result) {
      onChangeImage?.(photoResult.result);
    }
  }, [photoResult.isLoading, photoResult.result]);

  // 팝업 열림 지연 처리
  useEffect(() => {
    setTimeout(() => {
      setDelayedPopup(popup);
    }, DELAY_MINIMUM_OPEN_TIME);
  }, [popup]);

  return (
    <CommonPopup
      isOpen={delayedPopup === `imageUpload-${type}`}
      onClose={onClose}
      title={title}
      padding={0}
    >
      <div className="px-5 pb-[30px]">
        <div
          className={clsx([
            "grid",
            {
              "grid-cols-3": isProfile,
              "grid-cols-2": !isProfile,
            },
          ])}
        >
          <div
            className="flex flex-col justify-center items-center"
            onClick={() => {
              onCall?.();
              callCamera();
            }}
          >
            <TakePictureIcon />
            사진 촬영
          </div>
          <div
            className="flex flex-col justify-center items-center cursor-pointer"
            onClick={() => {
              onCall?.();
              callPhoto(maxCount);
            }}
          >
            <GalleryPictureIcon />
            갤러리
          </div>
          {isProfile && (
            <div
              className="flex flex-col justify-center items-center cursor-pointer"
              onClick={() => {
                onChangeImage?.([""]);
              }}
            >
              <DefaultImageIcon />
              기본 이미지
            </div>
          )}
        </div>
      </div>

      <CommonButton
        className="w-full h-bottom-button rounded-none"
        variant="secondary"
        onClick={onClose}
      >
        취소
      </CommonButton>
    </CommonPopup>
  );
}
